// @flow
import { media } from '~/core/utils/style';
import styled from 'styled-components';

export const Container = styled.div`
    margin: 1em;

    ${media.tablet`
		margin: 1.5em;
	`} ${media.desktop`
		margin: 2em;
	`};
`;

export const CompContainer = styled.div`
	font-size: 0.8em;
	margin-bottom: 2em;
	opacity: ${p => (p.hide ? 0 : 1)}

	transition: opacity 0.3s ease-out;
`;

export const Title = styled.h2`
	border-bottom: solid 1px ${p => p.theme.mediumGrey}
	padding-bottom: 0.3em;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/recipe-detail/style.js